module.exports = __webpack_public_path__ + "assets/home.1f74865a.svg";